import { render, staticRenderFns } from "./ErroNotificacao.vue?vue&type=template&id=e3aa03c6&scoped=true&"
import script from "./ErroNotificacao.vue?vue&type=script&lang=js&"
export * from "./ErroNotificacao.vue?vue&type=script&lang=js&"
import style0 from "./ErroNotificacao.vue?vue&type=style&index=0&id=e3aa03c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3aa03c6",
  null
  
)

export default component.exports